import { z } from "zod";
import { isValidPhoneNumber } from 'libphonenumber-js';
import validator from "validator";

const defaultCountry = "PT";

export const AccountSchema = z.object({
    id: z.number().positive().min(1),
    name: z.string().max(128),
    isAdministrator: z.boolean(),
    createdBy: z.number().positive().min(1),
    createdOn: z.date(),
    modifiedBy: z.number().positive().min(1),
    modifiedOn: z.date(),
    fiscalNumber: z.string().refine((str) => validator.isTaxID(str, 'pt-PT')),
    address: z.string().min(1),
    zipCode: z.string().refine((str) => validator.isPostalCode(str, 'PT')),
    city: z.string().min(1),
    email: z.string().email(),
    phoneNumber: z.string().refine((str) => isValidPhoneNumber(str, 'PT')),
    enabled: z.boolean(),
    description: z.string().max(10240).nullable().optional(),
    allowExternalManagers: z.boolean().default(false),
    maxInternalManagers: z.number().int().nullable().default(null),
});

export type Account = z.infer<typeof AccountSchema>;
